// Personele Borç Ekle / Personele Ödeme Yap penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'personnel.debt';

export const personnelDebtGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Personele borç / ödeme nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Personelin şirkete borçlandığı tutarı (borç) veya personele verdiğiniz parayı (ödeme, avans, maaş/prim ödemesi) kaydedersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Personele Borç Ekle / Personele Ödeme Yap'),
    body: t(`${G}.regions.body`, 'Yöntem, kasa/banka, tutar ve tarih'),
    footer: t(`${G}.regions.footer`, 'Borcu / Ödemeyi Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Hangi pencere açıldı?'),
      text: t(`${G}.s1.text`, '⋮ menüsündeki "Borç Ekle" pencereyi "Personele Borç Ekle" olarak açar. "Ödeme Ekle", "Avans Ver" ve maaş/prim pencerelerindeki "Ödeme Yap" ise "Personele Ödeme Yap" olarak açar. İkisi de personelin Güncel Bakiyesini tutar kadar artırır (şirketin alacağı artar).'),
      tips: [
        t(`${G}.s1.tip1`, '"Avans Ver" ile açıldığında açıklama "… için avans" olarak dolu gelir ve ödeme avans olarak işaretlenir; sonraki "Maaş Oluştur"da maaştan düşülmesi önerilir.'),
        t(`${G}.s1.tip2`, 'Maaş/prim ödemesinden açıldığında tutar ve açıklama hakedişten dolu gelir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Yöntemi seçin'),
      text: t(`${G}.s2.text`, '"İşlem Türü" / "Ödeme Yöntemi" alanında Tahakkuk, Nakit veya Banka seçin. Borç Ekle Tahakkuk ile, ödeme pencereleri Nakit ile açılır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Tahakkuk: para hareketi olmaz, yalnız personel defterine kayıt yazılır.'),
        t(`${G}.s2.tip2`, 'Nakit: "Kasa Seçimi"nden paranın çıkacağı kasayı seçin. Banka: "Banka Hesabı Seçimi"nden hesabı (alt hesaplar dahil) seçin.'),
        t(`${G}.s2.tip3`, 'Listelerde yalnız Türk Lirası (₺) kasa ve banka hesapları, yanlarında bakiyeleriyle görünür. Şube yöneticisi yalnız kendi şubesinin hesaplarını görür.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Tutar ve bakiye kontrolü'),
      text: t(`${G}.s3.text`, '"Borç Tutarı" / "Ödeme Tutarı" zorunludur ve sıfırdan büyük olmalıdır. Nakit veya Banka seçiliyse tutar seçilen kasanın/hesabın bakiyesini aşamaz; aşarsa "Yetersiz Bakiye" penceresi mevcut bakiyeyi gösterir ve kayıt yapılmaz. Tutarı veya kaynağı değiştirip tekrar deneyin.'),
      tips: [
        t(`${G}.s3.tip1`, 'Açıklama isteğe bağlıdır. "Proje (opsiyonel)" ile kaydı bir projeye bağlayabilirsiniz; kasa/banka hareketine de aynı proje yazılır. Şube yöneticisinde proje alanı görünmez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Geçmiş tarihli işlem'),
      text: t(`${G}.s4.text`, '"Geçmiş tarihli işlem yap" kutusunu işaretlerseniz "İşlem Tarihi" alanı açılır; ileri bir tarih seçilemez. Kayıt ve oluşan kasa/banka hareketi tamamen seçtiğiniz tarihe yazılır. İşaretlemezseniz bugünün tarihi kullanılır.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin ve etkisi'),
      text: t(`${G}.s5.text`, '"Borcu Kaydet" / "Ödemeyi Kaydet" kasa veya banka seçilmeden açılmaz. Nakit/Banka seçiliyse tutar seçilen kasadan/banka hesabından gider olarak düşülür; personel defterine kayıt yazılır ve Güncel Bakiye artar. Personel kaydı ile kasa/banka hareketi birlikte kaydedilir; biri başarısız olursa hiçbiri kaydedilmez.'),
      tips: [
        t(`${G}.s5.tip1`, 'Yanlış kaydı Personel Hareketleri tablosundaki çöp kutusuyla silebilirsiniz; bağlı kasa/banka hareketi de silinir ve para kasaya/bankaya geri eklenir.'),
      ],
    },
  ],
});
